
import {
  AgendamentoRPA
} from '../index';


export class LogProcessamentoRPA {
  "AgendamentoRPAId";
  "Mensagem";
  "TipoLog";
  "DataLog";
  "id";
  AgendamentoRPA;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LogProcessamentoRPA`.
   */
  static getModelName() {
    return "LogProcessamentoRPA";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LogProcessamentoRPA for dynamic purposes.
  **/
  static factory(data) {
    return new LogProcessamentoRPA(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'LogProcessamentoRPA',
      plural: 'LogProcessamentoRPAs',
      path: 'LogProcessamentoRPAs',
      properties: {
        "AgendamentoRPAId": {
          name: 'AgendamentoRPAId',
          type: 'number'
        },
        "Mensagem": {
          name: 'Mensagem',
          type: 'string'
        },
        "TipoLog": {
          name: 'TipoLog',
          type: 'string'
        },
        "DataLog": {
          name: 'DataLog',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        AgendamentoRPA: {
          name: 'AgendamentoRPA',
          type: 'AgendamentoRPA',
          model: 'AgendamentoRPA'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LogProcessamentoRPA.js